const stickyAtc = document.querySelector('.section-sticky-atc');
if (!stickyAtc) return;

// `atcForm` is inside the product-info container, so a packs-dropdown repaint
// replaces it with a fresh element. Re-query it on every init and re-bind, and
// re-run init when the container is repainted (`product-info-repainted`).
let atcForm = null;
let stickyAtcObserver = null;

init();
window.addEventListener('product-info-repainted', init);

function init() {
    atcForm = document.querySelector("[data-type=add-to-cart-form]");
    if (!atcForm) return;
    if (!stickyAtc.querySelector("button")) return;

    const submit = atcForm.querySelector(".product-form__submit:not(.hidden)");
    if (!submit) return;

    stickyAtc.querySelector("button").replaceWith(submit.cloneNode(true));
    stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    document.body.appendChild(stickyAtc);

    addEvents();
}

function addEvents() {
    stickyAtc.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        const btn = atcForm.querySelector(".product-form__submit:not(.hidden).button");
        if (btn) btn.click();
    });

    addObserver();

    atcForm.addEventListener('change', () => {
        const submit = atcForm.querySelector(".product-form__submit:not(.hidden)");
        if (!submit) return;
        stickyAtc.querySelector("button").replaceWith(submit.cloneNode(true));
        stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    });
}

function addObserver() {
    if (stickyAtcObserver) stickyAtcObserver.disconnect();
    stickyAtc.classList.remove('section-sticky-atc--visible');
    stickyAtcObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const stickyAtcRect = stickyAtc.getBoundingClientRect();
            const atcFormRect = atcForm.getBoundingClientRect();
            if (stickyAtcRect.bottom < atcFormRect.top) {
                // If stickyAtc is above atcForm, do not add the class
                return;
            }

            if (entry.isIntersecting) {
                stickyAtc.classList.remove('section-sticky-atc--visible');
            } else {
                stickyAtc.classList.add('section-sticky-atc--visible');
            }
        });
    }, {
        root: null,
        threshold: 0.2
    });

    stickyAtcObserver.observe(atcForm);
}
